import { animated, easings, useSpring } from '@react-spring/web';

export const Pane = ({ children, onClose, visible = true }) => {
  const [springs, api] = useSpring(() => ({
    from: { x: 450 },
    config: {
      easing: easings.easeOutQuad(500),
    },
  }));

  setTimeout(() => {
    if (visible) {
      api.start(() => ({
        to: { x: 0 },
      }));
    } else {
      api.start(() => ({
        to: { x: 450 },
      }));
    }
  }, 10);

  return (
    <animated.div className="pane" style={springs}>
      {onClose && (
        <div className="paneCloseButton" onClick={onClose}>
          <span className="material-icons">close</span>
        </div>
      )}
      {children}
    </animated.div>
  );
};
